import { createContext, useContext } from 'react';

export type FeedbackOptions = { rating?: number; source?: 'manual' | 'prompt' };
export const FeedbackContext = createContext<{
  available: boolean; promptVisible: boolean;
  open: (options?: FeedbackOptions) => void;
  dismissPrompt: (forever?: boolean) => void;
  promptShown: () => void;
}>({ available: false, promptVisible: false, open: () => {}, dismissPrompt: () => {}, promptShown: () => {} });
export const useFeedback = () => useContext(FeedbackContext);
